import React from "react";
import "../../css/sharedStyles.css";
import "./videoDetailOverlay.css";

var VideoDetailOverlay = class VideoDetailOverlay extends React.Component{
    constructor(props) {
        super(props);
        this.counter = 0;
        this.currentVideoPath;
    }  
    componentWillMount(){
      
    }//end componentDidMount() 

    closePopUP(){
        //im using a counter here so the 'videoPopupClose' and 'videoPopupBGClose' 
        //CSS animations dont fire on the page load
        this.props.changeVideoPopupVisibility(false);
        this.counter = 1;
        
        //cheap hack since NOTHING im doing in react is letting me target the youtube embed with JS
        //when we close the popup, we change the current selectedVideoID which youtube is playing.
        //when a new video loads, its not set to autoplay. so if the video popup is open, the video is playing,
        //and you close the popup, now it will appear as if the video stopped. But really i just change it
        //i need to grab an ID from the existing array so it also has the title, description ETC for below so
        //the page doesnt crash
        //Ill just always set the new video to the first one. IF youre already on the first one, then set
        //it to be the 2nd one. If it goes from 0 to 0, no change 
        //takes place and the video will keep playing after the popup is closed. 
        if(this.props.videoInfo.selectedVideoID === this.props.videoInfo.videosArray[0][0]){
            this.props.changeSelectedVideo(this.props.videoInfo.videosArray[1][0]);
        }
        else{
            this.props.changeSelectedVideo(this.props.videoInfo.videosArray[0][0]);
        }
         
    }





    render() {
        //using routing here for the page reload hack to update this.state
        const routeBase = localStorage.getItem("routeBase"); 

        this.currentVideoPath = "https://www.youtube.com/embed/" + this.props.videoInfo.selectedVideoID;
        var currentVideoID = this.props.videoInfo.selectedVideoID;
        
        //declare this here like this bc sometimes the app is looking for values in the array and its crashing
        //bc theres nothing in the array at the time of the call
        var currentVideoInfo = ['id','title','description','thumbnails','channel','published'];
        
        //find the videoArray we need based on the current Video ID in redux 
        var trimmedDate;
        this.props.videoInfo.videosArray.map(function(item,index){
            if(currentVideoID === item[0]){
                currentVideoInfo = item;
                var date = currentVideoInfo[5];
                trimmedDate = date.substring(0, date.indexOf('T'));
            }
            
        })//end map()

        //based on 'videoPopupVisible' in the video reducer, asign a CSS class
        if(this.props.videoInfo.videoPopupVisible === true){
            var showPopupBG = "videoPopupBGOpen"
            var showPopup = "videoPopupOpen"
        }
        else if (this.props.videoInfo.videoPopupVisible === false && this.counter !== 0){
            var showPopupBG = "videoPopupBGClose"
            var showPopup = "videoPopupClose"
        }
        else{
            var showPopupBG = ""
            var showPopup = ""            
        }

      return (
          
        <div className={"videoOverlayContainer " + showPopupBG}>
        {this.props.videoInfo.videoPopupVisible}
            <div className={"videoOverlay " + showPopup}>
                <div className = "videoOverlayContent">
                    <div className="videoIframeWrapper">
                        <iframe width="100%" height="auto" src={this.currentVideoPath} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
                    </div>
                    <div className="videoOverlayTitle">{currentVideoInfo[1]}</div>
                    <div className="videoOverlayDescription">{currentVideoInfo[2]}</div>
                </div>
                <div className="videoOverlayBottomArea">
                    <div className="">Channel Title | <span>{currentVideoInfo[4]}</span></div>
                    <div className="">Date Published | <span>{trimmedDate}</span></div>
                   
                        <div className="videoOverlayCloseButton"
                            onClick = {()=>{this.closePopUP()}}
                        >
                        Close Window 
                        </div>
                   
                </div>

            </div>



        </div>
      );
    }
  }

  export default VideoDetailOverlay;


// WEBPACK FOOTER //
// ./src/components/videoDetailOverlay/videoDetailOverlay.js